import React, { useEffect, useState } from 'react';
import Head from '../../../layout/head/Head';
import Content from '../../../layout/content/Content';
import { Block, BlockHead, BlockHeadContent, BlockTitle, Button, DataTableHead, DataTableItem, DataTableRow, Icon } from '../../../components/Component';
import moment from 'moment';
import AuthTenantLoader from '../../loaders/AuthTenantLoader';
import AuthTenantPageError from '../../error/AuthTenantPageError';
import { Alert, Card, Col, Row } from 'reactstrap';
import CardTabs from '../../components/cards/CardTabs';
import { TENANT_RETRIEVE_ORDER_REPORT_DATA_BY_DATE_API } from '../../../api/api_data';
import { fail_retrieve_tenant_order_analytics, loading_retrieve_tenant_order_analytics, reset_retrieve_tenant_order_analytics, success_retrieve_tenant_order_analytics } from '../../../reducers/auth_tenant/retrieve_tenant_order_analytics_Slice';
import { tenant_auth_actions_helper } from '../../../actions/actions_helper';
import { COULD_NOT_RETRIEVE_DATA_ERROR_MSG, COULD_NOT_RETRIEVE_DATA_SUCCESS_MSG } from '../../../utils/error_success_messages';
import { useSelector } from 'react-redux';
import { formatNumber, messageToast } from '../../../utils/Utils';
import * as app_consts from "../../../utils/app_consts";
import { useDispatch } from 'react-redux';
import { motion } from 'framer-motion';
import DatePicker from 'react-datepicker';
import { Line } from "react-chartjs-2";
import {
  Chart,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Tooltip,
  Filler,
  Legend,
} from "chart.js";
import { TrafficSourcesChart } from '../../../components/partials/charts/e-commerce/EcomCharts';
import AuthTenantNoData from '../../error/AuthTenantNoData';
import { Pie as ReactChartPie } from "react-chartjs-2";
import { Line as ReactChartLine } from "react-chartjs-2";
import BrandDistributionOrderReport from './data/BrandDistributionOrderReport';
import ProductTypeDistributionOrderReport from './data/ProductTypeDistributionOrderReport';
import ProductsDistributionOrderReport from './data/ProductsDistributionOrderReport';
import { download, generateCsv, mkConfig } from 'export-to-csv';

// Register necessary components
Chart.register(CategoryScale, LinearScale, PointElement, LineElement, Tooltip, Filler, Legend);

const initialState = { initial_start_date: moment().startOf("month").format("YYYY-MM-DD HH:mm:ss"), initial_end_date: moment().format("YYYY-MM-DD HH:mm:ss"), start_date: moment().startOf("month").format("YYYY-MM-DD HH:mm:ss"), end_date: moment().format("YYYY-MM-DD HH:mm:ss") };

const OrdersReportsManagement = ({ tenant_info, user_info }) => {

  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const [page_data, setPageData] = useState();
  const [activeCardTab, setActiveCardTab] = useState("Summary");
  const [form_data, setFormData] = useState(initialState);
  const [selectedRange, setSelectedRange] = useState([
    moment().startOf("month").toDate(),
    moment().toDate(),
  ]);
  const [retrieval_type, setRetrievalType] = useState(0);
  const [retriaval_loading, setRetrievalLoading] = useState(false);
  const [retrievalError, setRetrievalError] = useState("");
  const dispatch = useDispatch();
  const [showPicker, setShowPicker] = useState(false);

  // Card Tabs
  const tabs = [
    { tabName: "Summary" },
    { tabName: "Agency Distribution" },
    { tabName: "Sales Reps Distribution" },
    { tabName: "Brand Distribution" },
    { tabName: "Product Type Distribution" },
    { tabName: "Products Distribution" },
    { tabName: "Units Distribution" },
    { tabName: "Value Distribution" },
  ];

  useEffect(() => {
    retrieve_data();
  }, []);

  // Retrieve Data
  const retrieve_data = () => {
    setError("");
    setRetrievalError("");


    // Get the browser's timezone
    const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;

    // Get the browser's timezone offset in minutes
    const offsetMinutes = new Date().getTimezoneOffset();
    const offsetHours = Math.abs(offsetMinutes) / 60;
    const offsetSign = offsetMinutes > 0 ? "-" : "+";
    const formattedOffset = `${offsetSign}${String(offsetHours).padStart(2, "0")}:00`;


    // Dispatch
    dispatch(tenant_auth_actions_helper(
      loading_retrieve_tenant_order_analytics,
      success_retrieve_tenant_order_analytics,
      fail_retrieve_tenant_order_analytics,
      COULD_NOT_RETRIEVE_DATA_ERROR_MSG,
      COULD_NOT_RETRIEVE_DATA_SUCCESS_MSG,
      app_consts.GET,
      `/${tenant_info?.url_prefix}/${TENANT_RETRIEVE_ORDER_REPORT_DATA_BY_DATE_API}/${form_data.start_date}${formattedOffset}/${form_data.end_date}${formattedOffset}`
    ));
  };

  const retrieve_tenant_order_analytics_listener = useSelector((state) => state.retrieve_tenant_order_analytics.retrieve_tenant_order_analytics);

  useEffect(() => {
    if (retrieve_tenant_order_analytics_listener?.status !== app_consts.IDLE)
    {
      if (retrieve_tenant_order_analytics_listener?.status === app_consts.LOADING)
      {
        setError("");
        setRetrievalError("");
        if (retrieval_type === 0)
        {
          setLoading(true);
        }
        else
        {
          setRetrievalLoading(true);
        }
      } else
      {
        if (retrieve_tenant_order_analytics_listener?.status === app_consts.FAIL)
        {
          messageToast(retrieve_tenant_order_analytics_listener.message, app_consts.FAIL);
          if (retrieval_type === 0)
          {
            setError(retrieve_tenant_order_analytics_listener?.message);
          }
          else
          {
            setRetrievalError(retrieve_tenant_order_analytics_listener?.message);
          }
        }
        if (retrieve_tenant_order_analytics_listener?.status === app_consts.SUCCESS)
        {
          setPageData(retrieve_tenant_order_analytics_listener?.data);
        }
        dispatch(reset_retrieve_tenant_order_analytics());
        if (retrieval_type === 0)
        {
          setLoading(false);
        }
        else
        {
          setRetrievalType(0);
          setRetrievalLoading(false);
        }
      }
    }
  }, [retrieve_tenant_order_analytics_listener, retrieval_type]);


  const orderStats = [
    {
      label: "Total Orders",
      value: page_data?.total_orders_count || "0",
      icon: "box",
      color: "#6576ff",
      bg: "rgba(101, 118, 255, 0.1)",
    },
    {
      label: "Approved Orders",
      value: page_data?.total_approved_orders_count || "0",
      icon: "check-circle",
      color: "#1ee0ac",
      bg: "rgba(30, 224, 172, 0.1)",
    },
    {
      label: "Pending Submission Orders",
      value: page_data?.total_pending_submission_orders_count || "0",
      icon: "clock",
      color: "#f4bd0e",
      bg: "rgba(244, 189, 14, 0.1)",
    },
    {
      label: "Cancelled Orders",
      value: page_data?.total_cancelled_orders_count || "0",
      icon: "cross-circle",
      color: "#e85347",
      bg: "rgba(232, 83, 71, 0.1)",
    },
    {
      label: "Rejected Orders",
      value: page_data?.total_rejected_orders_count || "0",
      icon: "alert-circle",
      color: "#ff63a5",
      bg: "rgba(255, 99, 165, 0.1)",
    },
    {
      label: "Pending Reviews Orders",
      value: page_data?.total_pending_review_count || "0",
      icon: "eye",
      color: "#09c2de",
      bg: "rgba(9, 194, 222, 0.1)",
    },
    {
      label: "Dispatched Orders",
      value: page_data?.total_dispatched_orders_count || "0",
      icon: "truck",
      color: "#8b6ef3",
      bg: "rgba(139, 110, 243, 0.1)",
    },
    {
      label: "Pending Approval Orders",
      value: page_data?.total_pending_approval_count || "0",
      icon: "clock",
      color: "#f4bd0e",
      bg: "rgba(244, 189, 14, 0.1)",
    },
    {
      label: "Preparing for Dispatch Orders",
      value: page_data?.total_preparing_for_dispatch_orders_count || "0",
      icon: "package",
      color: "#09c2de",
      bg: "rgba(9, 194, 222, 0.1)",
    },
  ];

  const handleCustomRange = () => {
    setShowPicker(!showPicker);
  };


  const handleDateChange = (dates) => {
    const [start, end] = dates;

    setSelectedRange([start, end]); // This updates the calendar UI

    if (start && end)
    {
      setFormData({
        ...form_data,
        start_date: moment(start).format("YYYY-MM-DD 00:00:00"),
        end_date: moment(end).format("YYYY-MM-DD 23:59:59"),
      });
    }
  };

  const chartData = {
    labels: page_data?.order_frequency?.map(d => d.date),        // x-axis: dates
    datasets: [
      {
        label: "Orders",
        data: page_data?.order_frequency?.map(d => d.count),    // y-axis: order counts
        fill: true,
        backgroundColor: "rgba(101, 118, 255, 0.2)",
        borderColor: "#6576ff",
        tension: 0.3,
        pointRadius: 4,
        pointBackgroundColor: "#6576ff",
      },
    ],
  };

  const handleApply = () => {
    if (selectedRange.length === 2)
    {
      setRetrievalType(1);
      retrieve_data();
      setShowPicker(false);
    }
  };

  const options = {
    responsive: true,
    plugins: {
      legend: { display: true, position: "top" },
      tooltip: { enabled: true },
    },
    scales: {
      x: {
        title: { display: true, text: "Date" }
      },
      y: {
        title: { display: true, text: "Number of Orders" },
        beginAtZero: true,
        ticks: {
          // Force integers only
          callback: function (value) {
            return Number.isInteger(value) ? value : null;
          },
          stepSize: 1
        }
      },
    },
  };

  const unit_distribution_stats = [
    {
      label: "Total Ordered Units",
      value: page_data?.total_unit_distribution_sum || "0",
      icon: "box",
      color: "#6576ff",
      bg: "rgba(101, 118, 255, 0.1)",
    },
    {
      label: "Approved Order Units",
      value: page_data?.total_approved_unit_distribution_sum || "0",
      icon: "check-circle",
      color: "#1ee0ac",
      bg: "rgba(30, 224, 172, 0.1)",
    },
    {
      label: "Pending Submission Order Units",
      value: page_data?.total_pending_submission_unit_distribution_sum || "0",
      icon: "clock",
      color: "#f4bd0e",
      bg: "rgba(244, 189, 14, 0.1)",
    },
    {
      label: "Pending Reviews Order Units",
      value: page_data?.total_pending_review_unit_distribution_sum || "0",
      icon: "eye",
      color: "#09c2de",
      bg: "rgba(9, 194, 222, 0.1)",
    },
    {
      label: "Dispatched Order Units",
      value: page_data?.total_dispatched_unit_distribution_sum || "0",
      icon: "truck",
      color: "#8b6ef3",
      bg: "rgba(139, 110, 243, 0.1)",
    },
    {
      label: "Pending Approval Order Units",
      value: page_data?.total_pending_approval_unit_distribution_sum || "0",
      icon: "clock",
      color: "#f4bd0e",
      bg: "rgba(244, 189, 14, 0.1)",
    },
    {
      label: "Preparing for Dispatch Order Units",
      value: page_data?.total_preparing_for_dispatch_unit_distribution_sum || "0",
      icon: "package",
      color: "#09c2de",
      bg: "rgba(9, 194, 222, 0.1)",
    },
  ];

  const value_distribution_stats = [
    {
      label: "Total Ordered Units Value",
      value: page_data?.total_value_distribution_sum || "0",
      icon: "box",
      color: "#6576ff",
      bg: "rgba(101, 118, 255, 0.1)",
    },
    {
      label: "Approved Units Value",
      value: page_data?.total_approved_value_distribution_sum || "0",
      icon: "check-circle",
      color: "#1ee0ac",
      bg: "rgba(30, 224, 172, 0.1)",
    },
    {
      label: "Pending Submission Units Value",
      value: page_data?.total_pending_submission_value_distribution_sum || "0",
      icon: "clock",
      color: "#f4bd0e",
      bg: "rgba(244, 189, 14, 0.1)",
    },
    {
      label: "Pending Reviews Units Value",
      value: page_data?.total_pending_review_value_distribution_sum || "0",
      icon: "eye",
      color: "#09c2de",
      bg: "rgba(9, 194, 222, 0.1)",
    },
    {
      label: "Dispatched Units Value",
      value: page_data?.total_dispatched_value_distribution_sum || "0",
      icon: "truck",
      color: "#8b6ef3",
      bg: "rgba(139, 110, 243, 0.1)",
    },
    {
      label: "Pending Approval Units Value",
      value: page_data?.total_pending_approval_value_distribution_sum || "0",
      icon: "clock",
      color: "#f4bd0e",
      bg: "rgba(244, 189, 14, 0.1)",
    },
    {
      label: "Preparing for Dispatch Units Value",
      value: page_data?.total_preparing_for_dispatch_value_distribution_sum || "0",
      icon: "package",
      color: "#09c2de",
      bg: "rgba(9, 194, 222, 0.1)",
    },
  ];

  // uniquely named safe extraction of items
  const agencyDistributionItems =
    page_data?.total_grouped_agency_orders ?? [];

  const sortedAgencyDistributionItems =
    agencyDistributionItems?.slice().sort((a, b) => b.count - a.count) ?? [];

  const agencyDistributionChartData = {
    labels: sortedAgencyDistributionItems?.map((item) => item.agency_name) ?? [],
    datasets: [
      {
        data: sortedAgencyDistributionItems?.map((item) => item.count) ?? [],
        backgroundColor: sortedAgencyDistributionItems?.map(
          (_, idx) => `hsl(${(idx * 50) % 360}, 70%, 70%)`
        ),
        borderWidth: 1,
      },
    ],
  };

  // uniquely named chart options
  const agencyDistributionChartOptions = {
    cutout: "50%", // donut style
    plugins: {
      legend: {
        position: "bottom",
        labels: {
          font: { size: 13 },
          color: "#555",
          generateLabels: (chart) => {
            const dataset = chart.data.datasets[0];
            return chart.data.labels.map((label, i) => {
              const value = dataset.data[i];
              return {
                text: `${label} – ${value} Orders`,
                fillStyle: dataset.backgroundColor[i],
                strokeStyle: dataset.borderColor?.[i],
                lineWidth: 1,
                hidden: chart.getDataVisibility(i) === false,
                index: i,
              };
            });
          },
        },
      },
      tooltip: {
        callbacks: {
          label: (context) => {
            const label = context.label ?? "";
            const value = context.parsed ?? 0;
            const total = context.dataset.data.reduce((acc, val) => acc + val, 0);
            const percentage = ((value / total) * 100).toFixed(1);
            return `${label}: ${value} Orders (${percentage}%)`;
          },
        },
      },
    },
    maintainAspectRatio: false,
  };

  // Raw data
  const agencyOrdersFrequenciesRawData =
    page_data?.total_grouped_agency_order_frequencies ?? [];

  // All unique dates
  const agencyOrdersFrequenciesAllDates = Array.from(
    new Set(agencyOrdersFrequenciesRawData?.map((r) => r.date))
  ).sort((a, b) => new Date(a) - new Date(b));

  // Unique agencies
  const agencyOrdersFrequenciesUniqueAgencies = Array.from(
    new Set(agencyOrdersFrequenciesRawData?.map((r) => r.agency_name))
  );

  // Chart datasets
  const agencyOrdersFrequenciesChartDatasets = agencyOrdersFrequenciesUniqueAgencies.map(
    (agency, idx) => {
      const agencyOrdersFrequenciesDataPoints = agencyOrdersFrequenciesAllDates.map(
        (date) => {
          const record = agencyOrdersFrequenciesRawData.find(
            (r) => r.agency_name === agency && r.date === date
          );
          return record?.count ?? 0;
        }
      );

      return {
        label: agency,
        data: agencyOrdersFrequenciesDataPoints,
        borderColor: `hsl(${(idx * 50) % 360}, 70%, 50%)`,
        backgroundColor: `hsl(${(idx * 50) % 360}, 70%, 70%)`,
        fill: false,
        tension: 0.3,
        pointRadius: 4,
      };
    }
  );

  // Chart data object
  const agencyOrdersFrequenciesChartData = {
    labels: agencyOrdersFrequenciesAllDates,
    datasets: agencyOrdersFrequenciesChartDatasets,
  };

  // Chart options
  const agencyOrdersFrequenciesChartOptions = {
    responsive: true,
    plugins: {
      legend: {
        position: "bottom",
        labels: {
          font: { size: 13 },
          color: "#555",
        },
      },
      tooltip: {
        callbacks: {
          label: (context) => {
            const label = context.dataset.label ?? "";
            const value = context.parsed.y ?? 0;
            return `${label}: ${value} Orders`;
          },
        },
      },
    },
    scales: {
      x: { title: { display: true, text: "Date" } },
      y: {
        title: { display: true, text: "Number of Orders" },
        beginAtZero: true,
        ticks: {
          stepSize: 1,          // ensures only whole numbers
          callback: (value) => Math.round(value), // remove any decimal points
        },
      },
    },
    maintainAspectRatio: false,
  };

  const exportOrderStatsToCSV = () => {
    if (!orderStats || orderStats.length === 0)
    {
      console.warn("No orderStats data found to export.");
      return;
    }

    // Format date range from the form_data state
    const start = moment(form_data.start_date).format("YYYY-MM-DD");
    const end = moment(form_data.end_date).format("YYYY-MM-DD");
    const dateRange = `${start} to ${end}`;

    // CSV-ready rows with only the 3 keys you want
    const csvData = orderStats.map((stat) => ({
      date_range: dateRange,
      label: stat?.label,
      value: stat?.value,
    }));

    const csvConfig = mkConfig({
      filename: `order_stats_${start}_to_${end}`,
      fieldSeparator: ",",
      showLabels: true,
      useBom: true,
      useKeysAsHeaders: true,
    });

    const csv = generateCsv(csvConfig)(csvData);
    download(csvConfig)(csv);
  };

  const exportOrderFrequencyToCSV = () => {
    const freq = page_data?.order_frequency;

    if (!freq || freq.length === 0)
    {
      console.warn("No order frequency data available for export.");
      return;
    }

    const start = moment(form_data.start_date).format("YYYY-MM-DD");
    const end = moment(form_data.end_date).format("YYYY-MM-DD");
    const dateRange = `${start} to ${end}`;

    // Create simple rows for CSV
    const csvData = freq.map(d => ({
      date_range: dateRange,
      label: d.date,     // X-axis date
      value: d.count,    // Y-axis frequency
    }));

    const csvConfig = mkConfig({
      filename: `order_frequency_${start}_to_${end}`,
      fieldSeparator: ",",
      showLabels: true,
      useBom: true,
      useKeysAsHeaders: true,
    });

    const csv = generateCsv(csvConfig)(csvData);
    download(csvConfig)(csv);
  };

  const exportAgencyDistributionToCSV = () => {
    const items = agencyDistributionItems;

    if (!items || items.length === 0)
    {
      console.warn("No agency distribution data available for export.");
      return;
    }

    const start = moment(form_data.start_date).format("YYYY-MM-DD");
    const end = moment(form_data.end_date).format("YYYY-MM-DD");
    const dateRange = `${start} to ${end}`;

    const csvData = items.map(item => ({
      date_range: dateRange,
      Agency: item.agency_name,
      Count: item.count,
    }));

    const csvConfig = mkConfig({
      filename: `agency_distribution_${start}_to_${end}`,
      fieldSeparator: ",",
      showLabels: true,
      useBom: true,
      useKeysAsHeaders: true,
    });

    const csv = generateCsv(csvConfig)(csvData);
    download(csvConfig)(csv);
  };

  const exportAgencyOrdersOverTimeToCSV = () => {
    const data = agencyOrdersFrequenciesRawData;

    if (!data || data.length === 0)
    {
      console.warn("No agency orders frequency data available for export.");
      return;
    }

    const start = moment(form_data.start_date).format("YYYY-MM-DD");
    const end = moment(form_data.end_date).format("YYYY-MM-DD");
    const dateRange = `${start} to ${end}`;

    // CSV rows
    const csvData = data.map(item => ({
      date_range: dateRange,
      date: item.date,
      agency_name: item.agency_name,
      count: item.count,
    }));

    const csvConfig = mkConfig({
      filename: `agency_orders_over_time_${start}_to_${end}`,
      fieldSeparator: ",",
      showLabels: true,
      useBom: true,
      useKeysAsHeaders: true,
    });

    const csv = generateCsv(csvConfig)(csvData);
    download(csvConfig)(csv);
  };

  const exportAgencyOrderListToCSV = () => {
    const list = page_data?.agency_distribution_list;

    if (!list || list.length === 0)
    {
      console.warn("No agency order list data available for export.");
      return;
    }

    const start = moment(form_data.start_date).format("YYYY-MM-DD");
    const end = moment(form_data.end_date).format("YYYY-MM-DD");
    const dateRange = `${start} to ${end}`;

    const csvData = list.map(item => ({
      date_range: dateRange,
      agency_name: item.agency_name || "--",
      orders: item.count || 0,
      units_ordered: item.units_ordered || 0,
      value_ordered: item.value_ordered || 0,
      currency: "ZMW"
    }));

    const csvConfig = mkConfig({
      filename: `agency_order_list_${start}_to_${end}`,
      fieldSeparator: ",",
      showLabels: true,
      useBom: true,
      useKeysAsHeaders: true,
    });

    const csv = generateCsv(csvConfig)(csvData);
    download(csvConfig)(csv);
  };

  const exportSalesRepOrderListToCSV = () => {
    const list = page_data?.sales_rep_distribution_list;

    if (!list || list.length === 0)
    {
      console.warn("No sales rep order list data available for export.");
      return;
    }

    const start = moment(form_data.start_date).format("YYYY-MM-DD");
    const end = moment(form_data.end_date).format("YYYY-MM-DD");
    const dateRange = `${start} to ${end}`;

    const csvData = list.map(item => ({
      date_range: dateRange,
      sales_rep_name: item.sales_rep_name || "--",
      orders: item.count || 0,
      units_ordered: item.units_ordered || 0,
      value_ordered: item.value_ordered || 0,
      currency: "ZMW"
    }));

    const csvConfig = mkConfig({
      filename: `sales_rep_order_list_${start}_to_${end}`,
      fieldSeparator: ",",
      showLabels: true,
      useBom: true,
      useKeysAsHeaders: true,
    });

    const csv = generateCsv(csvConfig)(csvData);
    download(csvConfig)(csv);
  };

  const exportUnitDistributionStatsToCSV = () => {
    if (!unit_distribution_stats || unit_distribution_stats.length === 0)
    {
      console.warn("No unit distribution stats data available for export.");
      return;

    }
    const start = moment(form_data.start_date).format("YYYY-MM-DD");
    const end = moment(form_data.end_date).format("YYYY-MM-DD");
    const dateRange = `${start} to ${end}`;

    const csvData = unit_distribution_stats.map(stat => ({
      date_range: dateRange,
      label: stat.label,
      value: stat.value || 0,
      currency: "ZMW"
    }));

    const csvConfig = mkConfig({
      filename: `unit_distribution_stats_${start}_to_${end}`,
      fieldSeparator: ",",
      showLabels: true,
      useBom: true,
      useKeysAsHeaders: true,
    });

    const csv = generateCsv(csvConfig)(csvData);
    download(csvConfig)(csv);
  };

  const exportValueDistributionStatsToCSV = () => {
    if (!value_distribution_stats || value_distribution_stats.length === 0)
    {
      console.warn("No value distribution stats data available for export.");
      return;
    }
    const start = moment(form_data.start_date).format("YYYY-MM-DD");
    const end = moment(form_data.end_date).format("YYYY-MM-DD");
    const dateRange = `${start} to ${end}`;

    const csvData = value_distribution_stats.map(stat => ({
      date_range: dateRange,
      label: stat.label,
      value: stat.value || 0,
      currency: "ZMW"
    }));

    const csvConfig = mkConfig({
      filename: `value_distribution_stats`,
      fieldSeparator: ",",
      showLabels: true,
      useBom: true,
      useKeysAsHeaders: true,
    });

    const csv = generateCsv(csvConfig)(csvData);
    download(csvConfig)(csv);
  };

  return (
    <>
      <Head title={tenant_info?.name ? `${tenant_info.name} Orders Reports` : "Orders Reports"} />
      <Content>
        <BlockHead size="sm">
          <BlockHeadContent>
            <BlockTitle page>Orders Reports</BlockTitle>
          </BlockHeadContent>
        </BlockHead>

        <Block>


          {
            loading ? (
              <AuthTenantLoader tenant_info={tenant_info} loading_message="Loading Order Reports Data..." />
            ) : error ? (
              <AuthTenantPageError tenant_info={tenant_info} error_message={error} />
            ) : (
              <Block style={{ marginTop: '20px' }}>
                <Row className="g-gs" style={{ marginBottom: '20px' }}>
                  <motion.div
                    className="d-flex flex-column flex-sm-row align-items-sm-center justify-content-between flex-wrap bg-light p-3 mb-3"
                    initial={{ opacity: 0, y: -10 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ duration: 0.4 }}
                  >
                    <div className="mb-2 mb-sm-0">

                      {/* Toggle Button */}
                      <div className="d-flex align-items-center mb-2">
                        <Button color="primary" size="sm" onClick={handleCustomRange}>
                          {showPicker ? "Cancel" : "Custom Range"}
                        </Button>
                      </div>

                      {/* Conditional Date Range Picker */}
                      {showPicker && (
                        <motion.div
                          initial={{ opacity: 0, y: -10 }}
                          animate={{ opacity: 1, y: 0 }}
                          transition={{ duration: 0.3 }}
                          className="mb-3"
                        >
                          <label className="form-label fw-semibold text-muted mb-1">
                            Select Date Range
                          </label>

                          <DatePicker
                            selected={selectedRange[0]}
                            onChange={handleDateChange}
                            startDate={selectedRange[0]}
                            endDate={selectedRange[1]}
                            selectsRange
                            dateFormat="yyyy-MM-dd"
                            className="form-control"
                          />

                          <Button
                            color="success"
                            size="sm"
                            className="mt-2"
                            onClick={handleApply}
                            disabled={!form_data?.start_date || !form_data?.end_date || retriaval_loading}
                          >
                            {retriaval_loading ? "Retrieving Data" : "Apply"}
                          </Button>

                          {retrievalError && (
                            <Alert className="my-4" color="danger">
                              {retrievalError}
                            </Alert>
                          )}
                        </motion.div>
                      )}

                      {/* Display current date info */}
                      {!showPicker && (
                        <motion.div
                          initial={{ opacity: 0, y: -10 }}
                          animate={{ opacity: 1, y: 0 }}
                          transition={{ duration: 0.3 }}
                        >
                          <motion.div
                            className="bg-light border-start border-primary ps-3 py-2 mb-3 rounded"
                            initial={{ opacity: 0, x: -20 }}
                            animate={{ opacity: 1, x: 0 }}
                            transition={{ duration: 0.4, delay: 0.1 }}
                          >
                            <p className="text-muted mb-0" style={{ fontSize: "14px" }}>
                              📅 Showing data from{" "}
                              <span className="fw-semibold text-dark">
                                {form_data?.start_date}
                              </span>{" "}
                              up to{" "}
                              <span className="fw-semibold text-dark">
                                {form_data?.end_date}
                              </span>.
                            </p>
                          </motion.div>

                          <div style={{ backgroundColor: "#fff3cd", borderLeft: "4px solid #ffc107", padding: "12px 16px", borderRadius: "4px" }}> <p style={{ margin: 0, fontSize: "14px", color: "#856404" }}> ⚠️ Feature still under development — Partial Functionality is Currently Accessible. </p> </div>
                        </motion.div>
                      )}

                    </div>
                  </motion.div>
                  <Block>
                    <CardTabs cardTabs={tabs} activeCardTab={activeCardTab} setActiveCardTab={setActiveCardTab} />
                  </Block>

                  {
                    activeCardTab === "Summary" && (
                      <><div style={{ display: "flex", justifyContent: "flex-end", marginBottom: "15px" }}>
                        <Button color="primary" onClick={exportOrderStatsToCSV}>
                          Export Stats CSV
                        </Button>
                      </div>
                        {/* Stats Cards */}
                        {orderStats?.map((stat, idx) => (
                          <Col key={idx} xxl="3" sm="6">
                            <Card
                              style={{
                                borderRadius: "8px",
                                border: "1px solid #e5e9f2",
                                transition: "all 0.3s ease",
                                marginBottom: 0,
                                height: "100%",
                              }}
                            >
                              <div style={{ padding: "20px" }}>
                                <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
                                  <div>
                                    <h6 style={{ fontSize: "14px", color: "#6c757d", marginBottom: "8px" }}>
                                      {stat.label}
                                    </h6>
                                    <h2 style={{ fontSize: "24px", fontWeight: "600", margin: 0 }}>
                                      {stat.value}
                                    </h2>
                                  </div>
                                  <div
                                    style={{
                                      width: "48px",
                                      height: "48px",
                                      borderRadius: "50%",
                                      display: "flex",
                                      alignItems: "center",
                                      justifyContent: "center",
                                      fontSize: "24px",
                                      backgroundColor: stat.bg,
                                    }}
                                  >
                                    <Icon name={stat.icon} style={{ color: stat.color }} />
                                  </div>
                                </div>
                              </div>
                            </Card>
                          </Col>
                        ))}
                        <BlockHead>
                          <BlockTitle tag="h5" className="mt-2">Order Frequency</BlockTitle>
                        </BlockHead>
                        <div style={{ display: "flex", justifyContent: "flex-end", marginBottom: "15px" }}>
                          <Button color="primary" onClick={exportOrderFrequencyToCSV}>
                            Export Frequency CSV
                          </Button>
                        </div>
                        <Col xxl="12" md="12" style={{ marginBottom: '20px' }}>
                          <Card style={{ borderRadius: '8px', border: '1px solid #e5e9f2', height: '400px', overflow: 'hidden' }}>
                            <div style={{ padding: '20px', height: '100%' }}>
                              <div style={{ marginBottom: '16px' }}>
                                <h6 style={{ fontSize: '16px', fontWeight: '500', margin: 0 }}>Order Frequency</h6>
                              </div>
                              <div style={{ height: 'calc(100% - 56px)', position: 'relative' }}>
                                <Line data={chartData} options={{ ...options, maintainAspectRatio: false }} />
                              </div>
                            </div>
                          </Card>
                        </Col>
                      </>
                    )
                  }
                  {
                    activeCardTab === "Agency Distribution" && (
                      <>
                        <motion.div
                          initial={{ opacity: 0, y: -10 }}
                          animate={{ opacity: 1, y: 0 }}
                          transition={{ duration: 0.3 }}
                        >
                          <motion.div
                            className="bg-light border-start border-primary ps-3 py-2 mb-3 rounded"
                            initial={{ opacity: 0, x: -20 }}
                            animate={{ opacity: 1, x: 0 }}
                            transition={{ duration: 0.4, delay: 0.1 }}
                          >
                            <p className="text-muted mb-0" style={{ fontSize: "14px" }}>
                              Kindly Note that Agency Distribution Excludes Cancelled/Rejected Orders and is Based off of the Main Order Status.
                            </p>
                          </motion.div>

                          <Row className="g-gs">
                            <Col xxl="4" sm="6">
                              <Card className="card-full overflow-hidden">
                                <div className="nk-ecwg nk-ecwg4 h-100">
                                  {agencyDistributionItems?.length > 0 ? (
                                    <>
                                      <div className="card-inner flex-grow-1">
                                        <div className="card-title-group mb-4">
                                          <div className="card-title">
                                            <h6 className="title">Agency Distribution</h6>
                                          </div>
                                        </div>
                                        <div style={{ display: "flex", justifyContent: "flex-end", marginBottom: "10px" }}>
                                          <Button color="primary" onClick={exportAgencyDistributionToCSV}>
                                            Export Distribution CSV
                                          </Button>
                                        </div>
                                        <div className="data-group">
                                          <div className="nk-ecwg4-ck w-100" style={{ height: '320px', minHeight: '320px' }}>
                                            {agencyDistributionItems?.length > 0 && (
                                              <ReactChartPie
                                                data={agencyDistributionChartData}
                                                options={{
                                                  ...agencyDistributionChartOptions,
                                                  responsive: true,
                                                  maintainAspectRatio: false
                                                }}
                                              />
                                            )}
                                          </div>
                                        </div>
                                      </div>
                                    </>
                                  ) : (
                                    <AuthTenantNoData tenant_info={tenant_info} no_data_message="No Agency Distribution Data Found." />
                                  )}
                                  <div className="card-inner card-inner-md bg-light">
                                    <div className="card-note flex items-center gap-2">
                                      <Icon className="info-fill text-blue-500" />
                                      <span>Distribution of Total Orders Across Agencies.</span>
                                    </div>
                                  </div>
                                </div>
                              </Card>
                            </Col>

                            <Col xxl="8" sm="6">
                              <Card className="card-full overflow-hidden">
                                <div className="nk-ecwg nk-ecwg4 h-100">
                                  {agencyOrdersFrequenciesRawData?.length > 0 ? (
                                    <div className="card-inner flex-grow-1">
                                      <div className="card-title-group mb-4">
                                        <div className="card-title">
                                          <h6 className="title">Agency Orders Over Time</h6>
                                        </div>
                                      </div>
                                      <div style={{ display: "flex", justifyContent: "flex-end", marginBottom: "10px" }}>
                                        <Button color="primary" onClick={exportAgencyOrdersOverTimeToCSV}>
                                          Export Orders Over Time CSV
                                        </Button>
                                      </div>
                                      <div className="data-group">
                                        <div className="nk-ecwg4-ck w-100" style={{ height: '350px', minHeight: '350px' }}>
                                          {agencyOrdersFrequenciesRawData?.length > 0 && (
                                            <ReactChartLine
                                              data={agencyOrdersFrequenciesChartData}
                                              options={{
                                                ...agencyOrdersFrequenciesChartOptions,
                                                responsive: true,
                                                maintainAspectRatio: false
                                              }}
                                            />
                                          )}
                                        </div>
                                      </div>
                                    </div>
                                  ) : (
                                    <AuthTenantNoData tenant_info={tenant_info} no_data_message="No Agency Distribution Data Found." />
                                  )}
                                  <div className="card-inner card-inner-md bg-light">
                                    <div className="card-note flex items-center gap-2">
                                      <Icon className="info-fill text-blue-500" />
                                      <span>Number of orders per agency over time.</span>
                                    </div>
                                  </div>
                                </div>
                              </Card>
                            </Col>
                          </Row>
                          <BlockHead>
                            <BlockTitle tag="h5" className="mt-2">Agency Order List</BlockTitle>
                          </BlockHead>
                          <Block>
                            <div style={{ display: "flex", justifyContent: "flex-end", marginBottom: "10px" }}>
                              <Button color="primary" onClick={exportAgencyOrderListToCSV}>
                                Export Agency Orders CSV
                              </Button>
                            </div>
                            {
                              page_data?.agency_distribution_list && page_data?.agency_distribution_list?.length > 0 ?
                                <>
                                  <div className="nk-tb-list is-separate is-medium mb-3">
                                    <DataTableHead className="nk-tb-item">
                                      <DataTableRow><span className="sub-text">Agency</span></DataTableRow>
                                      <DataTableRow><span className="sub-text">Orders</span></DataTableRow>
                                      <DataTableRow><span className="sub-text">Units Ordered</span></DataTableRow>
                                      <DataTableRow><span className="sub-text">Value of Units Ordered</span></DataTableRow>
                                      {/* <DataTableRow><span className="sub-text">Action</span></DataTableRow> */}
                                    </DataTableHead>


                                    {page_data?.agency_distribution_list?.map((item) => (
                                      <DataTableItem key={item.id}>
                                        <DataTableRow>
                                          <div className="user-card">
                                            <div className="user-info">
                                              <span className="tb-lead">
                                                {item?.agency_name || "--"}
                                              </span>
                                            </div>
                                          </div>
                                        </DataTableRow>
                                        <DataTableRow>
                                          <span className="tb-lead">
                                            {item?.count || "--"}
                                          </span>
                                        </DataTableRow>
                                        <DataTableRow>
                                          <div className="user-card">
                                            <div className="user-info">
                                              <span className="tb-lead">{item?.units_ordered ? formatNumber(item?.units_ordered) : "--"}</span>
                                              <span></span>
                                            </div>
                                          </div>
                                        </DataTableRow>
                                        <DataTableRow>
                                          <div className="user-card">
                                            <div className="user-info">
                                              <span className="tb-lead">{item?.value_ordered ? `${formatNumber(item?.value_ordered)} ZMW` : "--"}</span>
                                              <span></span>
                                            </div>
                                          </div>
                                        </DataTableRow>
                                        {/* <DataTableRow>
                        <Link to={`/${tenant_info.url_prefix}/orders/${item?.order_ref_number}`}>
                          <Button color="primary" size="sm" className="btn btn-dim">
                            View
                          </Button>
                        </Link>
                      </DataTableRow> */}
                                      </DataTableItem>
                                    ))}
                                  </div>
                                </>
                                :
                                <>
                                  <AuthTenantNoData tenant_info={tenant_info} no_data_message="No Agency Distribution Data Found." />
                                </>
                            }
                          </Block>
                        </motion.div>
                      </>
                    )
                  }
                  {
                    activeCardTab === "Sales Reps Distribution" && (
                      <>
                        <motion.div
                          initial={{ opacity: 0, y: -10 }}
                          animate={{ opacity: 1, y: 0 }}
                          transition={{ duration: 0.3 }}
                        >
                          <motion.div
                            className="bg-light border-start border-primary ps-3 py-2 mb-3 rounded"
                            initial={{ opacity: 0, x: -20 }}
                            animate={{ opacity: 1, x: 0 }}
                            transition={{ duration: 0.4, delay: 0.1 }}
                          >
                            <p className="text-muted mb-0" style={{ fontSize: "14px" }}>
                              Kindly Note that Sales Reps Distribution Excludes Cancelled/Rejected Orders and is Based off of the Main Order Status.
                            </p>
                          </motion.div>
                          <BlockHead>
                            <BlockTitle tag="h5" className="mt-2">Sales Rep Order List</BlockTitle>
                          </BlockHead>
                          <div style={{ display: "flex", justifyContent: "flex-end", marginBottom: "10px" }}>
                            <Button color="primary" onClick={exportSalesRepOrderListToCSV}>
                              Export Sales Rep Orders CSV
                            </Button>
                          </div>
                          <Block>
                            {
                              page_data?.sales_rep_distribution_list && page_data?.sales_rep_distribution_list?.length > 0 ?
                                <>
                                  <div className="nk-tb-list is-separate is-medium mb-3">
                                    <DataTableHead className="nk-tb-item">
                                      <DataTableRow><span className="sub-text">Sales Rep</span></DataTableRow>
                                      <DataTableRow><span className="sub-text">Orders</span></DataTableRow>
                                      <DataTableRow><span className="sub-text">Units Ordered</span></DataTableRow>
                                      <DataTableRow><span className="sub-text">Value of Units Ordered</span></DataTableRow>
                                      {/* <DataTableRow><span className="sub-text">Action</span></DataTableRow> */}
                                    </DataTableHead>


                                    {page_data?.sales_rep_distribution_list?.map((item) => (
                                      <DataTableItem key={item.id}>
                                        <DataTableRow>
                                          <div className="user-card">
                                            <div className="user-info">
                                              <span className="tb-lead">
                                                {item?.sales_rep_name || "--"}
                                              </span>
                                            </div>
                                          </div>
                                        </DataTableRow>
                                        <DataTableRow>
                                          <span className="tb-lead">
                                            {item?.count || "--"}
                                          </span>
                                        </DataTableRow>
                                        <DataTableRow>
                                          <div className="user-card">
                                            <div className="user-info">
                                              <span className="tb-lead">{item?.units_ordered ? formatNumber(item?.units_ordered) : "--"}</span>
                                              <span></span>
                                            </div>
                                          </div>
                                        </DataTableRow>
                                        <DataTableRow>
                                          <div className="user-card">
                                            <div className="user-info">
                                              <span className="tb-lead">{item?.value_ordered ? `${formatNumber(item?.value_ordered)} ZMW` : "--"}</span>
                                              <span></span>
                                            </div>
                                          </div>
                                        </DataTableRow>
                                        {/* <DataTableRow>
                        <Link to={`/${tenant_info.url_prefix}/orders/${item?.order_ref_number}`}>
                          <Button color="primary" size="sm" className="btn btn-dim">
                            View
                          </Button>
                        </Link>
                      </DataTableRow> */}
                                      </DataTableItem>
                                    ))}
                                  </div>
                                </>
                                :
                                <>
                                  <AuthTenantNoData tenant_info={tenant_info} no_data_message="No Agency Distribution Data Found." />
                                </>
                            }
                          </Block>
                        </motion.div>
                      </>
                    )
                  }
                  {
                    activeCardTab === "Brand Distribution" && (
                      <>
                        <BrandDistributionOrderReport tenant_info={tenant_info} data={page_data} />
                      </>
                    )
                  }
                  {
                    activeCardTab === "Product Type Distribution" && (
                      <>
                        <ProductTypeDistributionOrderReport tenant_info={tenant_info} data={page_data} />
                      </>
                    )
                  }
                  {
                    activeCardTab === "Products Distribution" && (
                      <>
                        <ProductsDistributionOrderReport tenant_info={tenant_info} data={page_data} />
                      </>
                    )
                  }
                  {
                    activeCardTab === "Units Distribution" && (
                      <>
                        <motion.div
                          initial={{ opacity: 0, y: -10 }}
                          animate={{ opacity: 1, y: 0 }}
                          transition={{ duration: 0.3 }}
                        >
                          <motion.div
                            className="bg-light border-start border-primary ps-3 py-2 mb-3 rounded"
                            initial={{ opacity: 0, x: -20 }}
                            animate={{ opacity: 1, x: 0 }}
                            transition={{ duration: 0.4, delay: 0.1 }}
                          >
                            <p className="text-muted mb-0" style={{ fontSize: "14px" }}>
                              Kindly Note that Unit Distribution Excludes Cancelled/Rejected Orders and is Based off of the Main Order Status.
                            </p>
                          </motion.div>
                        </motion.div>
                        <div style={{ display: "flex", justifyContent: "flex-end", marginBottom: "10px" }}>
                          <Button color="primary" onClick={exportUnitDistributionStatsToCSV}>
                            Export Unit Distribution Stats CSV
                          </Button>
                        </div>
                        {/* Stats Cards */}
                        {unit_distribution_stats?.map((stat, idx) => (
                          <Col key={idx} xxl="3" sm="6">
                            <Card
                              style={{
                                borderRadius: "8px",
                                border: "1px solid #e5e9f2",
                                transition: "all 0.3s ease",
                                marginBottom: 0,
                                height: "100%",
                              }}
                            >
                              <div style={{ padding: "20px" }}>
                                <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
                                  <div>
                                    <h6 style={{ fontSize: "14px", color: "#6c757d", marginBottom: "8px" }}>
                                      {stat.label}
                                    </h6>
                                    <h2 style={{ fontSize: "24px", fontWeight: "600", margin: 0 }}>
                                      {stat.value}
                                    </h2>
                                  </div>
                                  <div
                                    style={{
                                      width: "48px",
                                      height: "48px",
                                      borderRadius: "50%",
                                      display: "flex",
                                      alignItems: "center",
                                      justifyContent: "center",
                                      fontSize: "24px",
                                      backgroundColor: stat.bg,
                                    }}
                                  >
                                    <Icon name={stat.icon} style={{ color: stat.color }} />
                                  </div>
                                </div>
                              </div>
                            </Card>
                          </Col>
                        ))}
                      </>
                    )
                  }
                  {
                    activeCardTab === "Value Distribution" && (
                      <>
                        <motion.div
                          initial={{ opacity: 0, y: -10 }}
                          animate={{ opacity: 1, y: 0 }}
                          transition={{ duration: 0.3 }}
                        >
                          <motion.div
                            className="bg-light border-start border-primary ps-3 py-2 mb-3 rounded"
                            initial={{ opacity: 0, x: -20 }}
                            animate={{ opacity: 1, x: 0 }}
                            transition={{ duration: 0.4, delay: 0.1 }}
                          >
                            <p className="text-muted mb-0" style={{ fontSize: "14px" }}>
                              Kindly Note that Value Distribution Excludes Cancelled/Rejected Orders and is Based off of the Main Order Status.
                            </p>
                          </motion.div>
                        </motion.div>
                        <div style={{ display: "flex", justifyContent: "flex-end", marginBottom: "10px" }}>
                          <Button color="primary" onClick={exportValueDistributionStatsToCSV}>
                            Export Value Distribution Stats CSV
                          </Button>
                        </div>
                        {/* Stats Cards */}
                        {value_distribution_stats?.map((stat, idx) => (
                          <Col key={idx} xxl="3" sm="6">
                            <Card
                              style={{
                                borderRadius: "8px",
                                border: "1px solid #e5e9f2",
                                transition: "all 0.3s ease",
                                marginBottom: 0,
                                height: "100%",
                              }}
                            >
                              <div style={{ padding: "20px" }}>
                                <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
                                  <div>
                                    <h6 style={{ fontSize: "14px", color: "#6c757d", marginBottom: "8px" }}>
                                      {stat.label}
                                    </h6>
                                    <h2 style={{ fontSize: "24px", fontWeight: "600", margin: 0 }}>
                                      {formatNumber(stat.value)} {` `} ZMW
                                    </h2>
                                  </div>
                                  <div
                                    style={{
                                      width: "48px",
                                      height: "48px",
                                      borderRadius: "50%",
                                      display: "flex",
                                      alignItems: "center",
                                      justifyContent: "center",
                                      fontSize: "24px",
                                      backgroundColor: stat.bg,
                                    }}
                                  >
                                    <Icon name={stat.icon} style={{ color: stat.color }} />
                                  </div>
                                </div>
                              </div>
                            </Card>
                          </Col>
                        ))}
                      </>
                    )
                  }
                </Row>
              </Block>
            )
          }
        </Block>
      </Content>
    </>
  );
};


export default OrdersReportsManagement;
